import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Explore.css";
import productData from "../Products/productData";

import {
  FaBluetoothB,
  FaChargingStation,
  FaLightbulb,
  FaShieldAlt,
} from "react-icons/fa";

const Explore = () => {
  const location = useLocation();

  /* 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA */
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye ho to "smooth"
    });
  }, []);

  // ✅ HOOKS MUST BE AT TOP
  const [activeImage, setActiveImage] = useState(null);

  // ✅ SAFE DEFAULTS
  const id = location.state?.id;
  const product = productData.find((p) => p.id === id);

  // ✅ EFFECT ALWAYS CALLED
  useEffect(() => {
    if (product?.allImages?.length) {
      setActiveImage(product.allImages[0]);
    }
  }, [product]);

  // ✅ EARLY RETURNS AFTER HOOKS
  if (!location.state) return null;
  if (!product) return <p>Product not found.</p>;

  const { name, allImages, full_detail, colors, image } = product;

  return (
    <section className="explore-page">
      {/* ================= NOVA PRODUCT SECTION ================= */}
      <section className="nova-wrap">
        {/* LEFT IMAGE */}
        <div className="nova-left">
          <h1 className="nova-watermark">WARIVO</h1>
          <img src={image} alt={name} />
        </div>

        {/* CENTER STRIP */}
        <div className="nova-center">
          <span>{name}</span>
        </div>

        {/* RIGHT CONTENT */}
        <div className="nova-right">
          <h2>{name}</h2>
          <p>
            Ride with clarity and intelligence: bright illumination, sleek
            dashboard, and smart connectivity
          </p>

          <div className="nova-cards">
            <div className="nova-card">
              <FaBluetoothB />
              <span>Smart Connectivity</span>
            </div>

            <div className="nova-card">
              <FaChargingStation />
              <span>Type C + USB Charging Port</span>
            </div>

            <div className="nova-card">
              <FaLightbulb />
              <span>{full_detail.Headlight}</span>
            </div>

            <div className="nova-card">
              <FaShieldAlt />
              <span>
                {full_detail?.Warranty?.Battery ||
                  "Standard Warranty Available"}
              </span>
            </div>
          </div>

          <button className="nova-btn">BOOK {name} NOW</button>
        </div>
      </section>

      {/* ================= IMAGE PREVIEW ================= */}
      <div className="explore-center">
        <div className="image-preview-box">
          <div className="preview-left">
            {activeImage && <img src={activeImage} alt="Active Scooter" />}
          </div>

          <div className="preview-right">
            {allImages.map((img, index) => (
              <img
                key={index}
                src={img}
                alt={`thumb-${index}`}
                className={activeImage === img ? "active" : ""}
                onClick={() => setActiveImage(img)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ================= DETAILS TABLE ================= */}
      <div className="specs-wrapper">
        <div className="specs-card">
          {product.full_detail.Dimension && (
            <div className="specs-row">
              <div className="specs-col title">Dimension</div>
              <div className="specs-col label">
                {Object.keys(product.full_detail.Dimension)[0]}
              </div>
              <div className="specs-col value">
                {Object.values(product.full_detail.Dimension)[0]}
              </div>
            </div>
          )}

          {product.full_detail.Brake && (
            <div className="specs-row">
              <div className="specs-col title">Brake</div>
              <div className="specs-col label">Type</div>
              <div className="specs-col value">
                {product.full_detail.Brake.Type}
              </div>
            </div>
          )}

          {product.full_detail.Tyre && (
            <div className="specs-row">
              <div className="specs-col title">Tyre</div>
              <div className="specs-col label">
                <div className="border_line">Type</div>
                <div className="border_line">Front</div>
                <div>Rear</div>
              </div>
              <div className="specs-col value">
                <div className="border_line">
                  {product.full_detail.Tyre.Type}
                </div>
                <div className="border_line">
                  {product.full_detail.Tyre.Front}
                </div>
                <div>{product.full_detail.Tyre.Rear}</div>
              </div>
            </div>
          )}

          {product.full_detail.Suspension && (
            <div className="specs-row">
              <div className="specs-col title">Suspension</div>
              <div className="specs-col label">
                <div className="border_line">Front</div>
                <div>Rear</div>
              </div>
              <div className="specs-col value">
                <div className="border_line">
                  {product.full_detail.Suspension.Front}
                </div>
                <div>{product.full_detail.Suspension.Rear}</div>
              </div>
            </div>
          )}

          {product.full_detail["Kerb Weight w/o battery"] && (
            <div className="specs-row">
              <div className="specs-col title">Kerb weight w/o battery</div>
              <div className="specs-col label">KG</div>
              <div className="specs-col value">
                {product.full_detail["Kerb Weight w/o battery"].KG}
              </div>
            </div>
          )}

          {product.full_detail["Front Wheel Rim"] && (
            <div className="specs-row">
              <div className="specs-col title">Front Wheel Rim</div>
              <div className="specs-col label">Type</div>
              <div className="specs-col value">
                {product.full_detail["Front Wheel Rim"].Type}
              </div>
            </div>
          )}

          {product.full_detail.battery && (
            <div className="specs-row">
              <div className="specs-col title">Battery</div>
              <div className="specs-col value">
                {product.full_detail.battery.join(" / ")}
              </div>
            </div>
          )}

          {product.full_detail.range && (
            <div className="specs-row">
              <div className="specs-col title">Range</div>
              <div className="specs-col value">
                {product.full_detail.range[0]}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Explore;
